import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaUltraFeesMenuRegistry = {
    personalize_nebulaUltraFees: {
        label: "Nebula Ultra Fees",
        link: PAGE_URL.NEBULA_ULTRA_FEES_PAGE,
        key: PAGE_URL.NEBULA_ULTRA_FEES_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaUltraFeesMenuRegistry;
